import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { ChallanService } from 'src/app/_services/Challan/challan.service';
import { jsPDF, Html2CanvasOptions } from 'jspdf';
import {  ActivatedRoute,  } from '@angular/router';
import { Dateconfig } from 'src/app/configuration/dateconfig/dateconfig';
 import * as html2pdf from 'html2pdf.js';
//import * as jsPDF from 'jspdf';
//import jsPDF from 'jspdf';
import { Commonvariable } from 'src/app/commonvariable/commonvariable';

import html2canvas from 'html2canvas';
import { CustomLoaderCComponent } from 'src/app/CustomLoader/custom-loader/custom-loader-c/custom-loader-c.component';
@Component({
  selector: 'app-viewchallan',
  templateUrl: './viewchallan.component.html',
  styleUrls: ['./viewchallan.component.css'],
  providers:[Dateconfig,Commonvariable,CustomLoaderCComponent]
})
export class ViewchallanComponent implements OnInit {

  
  @ViewChild('invoicetemplate') contentPDF:ElementRef;  
  idChallan:string;
  temp = [];
  rows: any;
  temp2 : any;
  lstChallansItems = [];
  public breadcrumb: any;
  model: any = {};
 
  
  constructor(private router:ActivatedRoute,
    private ChallanService:ChallanService,
    private dateconfig:Dateconfig,
    private spinner:CustomLoaderCComponent
    ) { }
 ;
  ngOnInit() {
 
this.idChallan = this.router.snapshot.queryParamMap.get('Id');
this.idChallan=atob(this.idChallan)

    this.breadcrumb = {
      'mainlabel': 'View Challan',
      'links': [
        {
          'name': 'Home',
          'isLink': true,
          'link': '/dashboard/newdashboard'
        },

      ]
    };
    this.spinner.showSpinner();
    this.ChallanService.getbyidchallan(Number(this.idChallan)).subscribe(Response => {
     
      this.rows = Response;
      this.temp2 = Response;
      this.temp = this.rows;
      this.model = this.rows;
      this.model=Response;
      this.lstChallansItems = this.rows.lstChallanItems;
    this.spinner.hideSpinner();

    });
  }

createPdf() {
 

//  var data = document.getElementById('invoice-template');
//  window.scrollTo(0,0);  
//   html2canvas(data).then(canvas => {
//   // Few necessary setting options

//   var imgWidth = 208;
//   var pageHeight = 295;
//   var imgHeight = canvas.height * imgWidth / canvas.width;
//   var heightLeft = imgHeight;
   
//   const contentDataURL = canvas.toDataURL('image/jpeg',1.0);
  
//   let pdf = new jsPDF('p', 'mm', 'A4'); // A4 size page of PDF
//   var position = 0;
//   pdf.addImage(contentDataURL, 'jpeg', 0, 0, imgWidth, imgHeight);
//  //pdf.addImage(contentDataURL, 'PNG', 15, 40,180,180);

//   pdf.save('Ch'+( "000"+ this.model.challanNo).slice(-3)+'.pdf');


  
 

// });



// let doc1=new jsPDF();

//   let specialElementHandlers={
//     '#editor':function(element,renderer){
//       return true
//     }
//   };
//   let contentPDF=this.contentPDF.nativeElement;
//   doc1.fromHTML(contentPDF.innerHTML,15,15,{
//     'width':190,
//     'elementHandlers':specialElementHandlers
//   });
//   doc1.save("a.pdf");


// const options={
//   filename:'Ch'+( "000"+ this.model.challanNo).slice(-3)+'.pdf',
//   image:{type:'png'},
//   html2canvas:{},
//   jsPDF:{orientation: 'portrait' }   
// }
// const content:Element=document.getElementById('invoice-template');
// window.scrollTo(0,0); 
// html2pdf().
// from(content)
// .set(options)
// .save()




}
  getPrint(templet) {
    const printContents = document.getElementById(templet).innerHTML;
    const originalContents = document.body.innerHTML;
    document.body.innerHTML = printContents;
    document.title='Ch'+( "000"+ this.model.challanNo).slice(-3)+'.pdf'
    window.print();
    document.body.innerHTML = originalContents;
    location.reload();
    
  }

  convertoshort(date){
    return this.dateconfig.shortyydd(date);
  }

}
